/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Go_To_End_TitleInputs */

const en_player_go_to_end_title = /** @type {(inputs: Player_Go_To_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go To End`)
};

const fr_player_go_to_end_title = /** @type {(inputs: Player_Go_To_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller a la Fin`)
};

const de_player_go_to_end_title = /** @type {(inputs: Player_Go_To_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Ende springen`)
};

const it_player_go_to_end_title = /** @type {(inputs: Player_Go_To_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai alla fine`)
};

const ru_player_go_to_end_title = /** @type {(inputs: Player_Go_To_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти к концу`)
};

const es_player_go_to_end_title = /** @type {(inputs: Player_Go_To_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al final`)
};

const zh_cn2_player_go_to_end_title = /** @type {(inputs: Player_Go_To_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往结尾`)
};

const ja_player_go_to_end_title = /** @type {(inputs: Player_Go_To_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最後へ移動`)
};

const hi_player_go_to_end_title = /** @type {(inputs: Player_Go_To_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंत तक जाएं`)
};

const pt_pt2_player_go_to_end_title = /** @type {(inputs: Player_Go_To_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para o fim`)
};

/**
* | output |
* | --- |
* | "Go To End" |
*
* @param {Player_Go_To_End_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_go_to_end_title = /** @type {((inputs?: Player_Go_To_End_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Go_To_End_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_go_to_end_title(inputs)
	if (locale === "de") return de_player_go_to_end_title(inputs)
	if (locale === "it") return it_player_go_to_end_title(inputs)
	if (locale === "ru") return ru_player_go_to_end_title(inputs)
	if (locale === "es") return es_player_go_to_end_title(inputs)
	if (locale === "zh-CN") return zh_cn2_player_go_to_end_title(inputs)
	if (locale === "ja") return ja_player_go_to_end_title(inputs)
	if (locale === "hi") return hi_player_go_to_end_title(inputs)
	if (locale === "pt-PT") return pt_pt2_player_go_to_end_title(inputs)
	return en_player_go_to_end_title(inputs)
});